module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("efyyw"))).then(() => parcelRequire('d0iPb'));